/* eslint-disable */
import React from 'react';
import dayjs from 'dayjs';
import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import Utils from 'src/utils';
import { selectDesignations } from 'src/redux/selectors/UserSelectors';
import { IStore } from 'src/redux/store';
import { useSelector } from 'react-redux';
import { IDesginationStore } from 'src/redux/reducers/user';

export const Greeting = React.memo((props: any) => {
  const { user } = props;
  const roles = user?.roles;
  const designation = user?.designation;

  const designations = useSelector((store: IStore) =>
    selectDesignations(store)
  ) as IDesginationStore;

  const currentUserDesignation = designations.find((des) => des.id === designation)?.name;

  const roleMessage =
    designations.length && user && designation && designation !== ''
      ? `you are logged in as ${Utils.capitalizeFirstStringChar(
          currentUserDesignation || designation,
          undefined
        )} ${designation === 'super agent' ? '🚀' : ''}`
      : roles.join('').includes('admin')
        ? 'you are logged in as Admin'
        : user && roles?.join('').includes('aggregator')
          ? 'you are logged in as Aggregator'
          : !roles.join('').includes('admin') && roles.length > 1
            ? `your roles are: ${roles.join().split('*:')[1]}
                  ${roles
                    .join()
                    .split('*:')
                    .filter((_: string, i: number) => i !== 1)
                    .join(' ')}`
            : ` you are logged in as${roles.join().split('*:').join(' ')}`;

  return (
    <div className="hd-greeting">
      <div className="d-flex align-items-start">
        <span className="hd-greeting-icon">👋</span>
        <div>
          <h3 className="hd-greeting-title" style={{ textTransform: 'capitalize' }}>
            Hi {user && user.firstName},
          </h3>
          <div className="hd-greeting-subtitle">{roleMessage}</div>
        </div>
      </div>
      <div className="hd-system-info">
        <span>
          <CalendarOutlined /> {dayjs().format('MMM D, YYYY')}
        </span>
        <span>
          <ClockCircleOutlined /> {dayjs().format('HH:mm')}
        </span>
        <span className="hd-status-pill">System Online</span>
      </div>
    </div>
  );
});
